import Link from 'next/link'
import { type ReactElement } from 'react'

interface Args {
  children: React.ReactNode
  path: string
}

interface LimitedArgs {
  children: React.ReactNode
}

export function RpTableCell ({ children, path }: Args): ReactElement {
  return (
    <td className="p-0 h-12 relative">
      <Link href={path}>
        <div className="flex items-center w-full h-12 px-4 py-2">
          {children}
        </div>
      </Link>
    </td>
  )
}

export function NonLinkingTableCell ({ children }: LimitedArgs): ReactElement {
  return (
    <td className="p-0 h-12 relative">

      <div className="flex items-center w-full h-12 px-4 py-2">
        {children}
      </div>

    </td>
  )
}
